module.exports = __webpack_public_path__ + "img/logo-icon.44951bf8.png";